import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Switch, Link } from 'react-router-dom';
import './App.css';
import EventList from './components/EventList';
import EventDetails from './components/EventDetails';
import Login from './components/Login';
import Admin from './components/Admin';
import TeamAdmin from './components/TeamAdmin';
import UserStatistik from './components/UserStatistik';
import UserDetail from './components/UserDetail';
import Header from './components/Header';
import api from './api';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      api.get('/auth/me')
        .then(res => {
          setUser(res.data);
          setLoading(false);
        })
        .catch(() => {
          localStorage.removeItem('token');
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('token');
    setUser(null);
  };

  if (loading) return <div className="container">Lädt...</div>;

  return (
    <Router>
      <div className="App">
        <Header user={user} onLogout={() => setUser(null)} />

        <main className="container">
          <Switch>
            <Route exact path="/">
              {user ? <EventList user={user} /> : <Login setUser={setUser} />}
            </Route>
            <Route path="/login">
              <Login setUser={setUser} />
            </Route>
            <Route path="/admin/user/:id">
              {user && user.is_admin ? <UserDetail /> : <Login setUser={setUser} />}
            </Route>
            <Route path="/admin/:tab">
              {user && user.is_admin ? <Admin user={user} /> : <Login setUser={setUser} />}
            </Route>
            <Route exact path="/admin">
              {user && user.is_admin ? <Admin user={user} /> : <Login setUser={setUser} />}
            </Route>
            <Route path="/team-admin">
              {user && (user.is_team_admin || user.is_admin) ? <TeamAdmin user={user} /> : <Login setUser={setUser} />}
            </Route>
            <Route path="/profil">
              {user ? <UserStatistik user={user} setUser={setUser} /> : <Login setUser={setUser} />}
            </Route>
            <Route path="/event/:id">
              <EventDetails user={user} />
            </Route>
          </Switch>
        </main>
      </div>
    </Router>
  );
}

export default App;
